import React from "react";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const LogOut = ({ className }) => {
    return (
        <button
            type="button"
            className={ className }
            onClick={ () => {
                cookies.remove("tpir", { path: "/" });
                window.location.reload();
            } }
        >
            Log out
        </button>
    );
};

export default LogOut;
